import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

import PropTypes from "prop-types";

import { tagular } from "@cohesion/tagular";

import { ArticleCard } from "./article";

export function Articles({ slugs = [] }) {
  const [articles, setArticles] = useState([]);

  const { ref, inView } = useInView({
    threshold: 1,
    triggerOnce: true,
  });

  useEffect(() => {
    if (inView) {
      slugs.forEach(slug => {
        tagular("view", {
          webElement: {
            location: "BITDESTINATION",
            elementType: "LINK",
            position: "ARTICLE",
            text: slug,
          },
        });
      });
    }
  }, [inView, slugs]);

  useEffect(() => {
    const getArticles = async () => {
      const res = slugs.reduce(async (acc, slug) => {
        const next = await acc;

        try {
          const capi = await fetch(`/api/bit/articles/${slug.split("/")[2]}`);
          const response = await capi.json();

          if (!response || !response.article) {
            // eslint-disable-next-line no-console
            console.error(`Article not found or response is null for ${slug}`);
            return next; // Continue with the next iteration
          }

          const { article } = response;

          if (!article) {
            // eslint-disable-next-line no-console
            console.log(`No article found for ${slug}`);
            return next;
          }

          next.push({ ...article, slug });
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(`Error fetching article for ${slug}: ${error}`);
          return next; // Continue with the next iteration
        }

        return next;
      }, Promise.resolve([]));

      const x = await res;
      setArticles(x);
    };

    getArticles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="p-6 bg-white lg:px-12">
      <h3 className="mb-6 text-2xl font-normal font-neue">Plan your trip</h3>

      <ul className="space-y-4" ref={ref}>
        {articles?.length > 0 &&
          articles.map(article => (
            <li key={article.slug}>
              <ArticleCard {...article} type="article" />
            </li>
          ))}
      </ul>
    </div>
  );
}

Articles.propTypes = {
  slugs: PropTypes.arrayOf(PropTypes.string),
};
